import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthStateService } from "../services/authstate.service";
import { NavbarService } from "../services/navbar.service";

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private router: Router, private authState: AuthStateService, private nav: NavbarService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // ACCESS LEVELS
        // 1 = ADMIN FUL LACCESS
        // 2 = ADMIN LIMITED ACCESS
        // 3 = ADMIN READONLY
        // 4 = ADMIN STATION MANAGER
        // 9 = PUBLIC USER

        interface RouteConfig {
            savePath: boolean;
            navbar: {
                visible: boolean;
                bottomBorder: string;
            };
            accessLevel: string[];
        }

        const defaultConfig: RouteConfig = {
            savePath: true,
            navbar: {
                visible: true,
                bottomBorder: "VISIBLE"
            },
            accessLevel: ["1", "2", "3", "4", "9"]
        };

        const config = {
            ...defaultConfig,
            ...route.data,
            navbar: {
                ...defaultConfig.navbar,
                ...(route.data?.["navbar"] || {})
            }
        };

        let curAccessLevel = this.authState.loginData?.user?.authLevel;

        if (config.accessLevel.includes(String(curAccessLevel)) || (curAccessLevel === undefined && config.accessLevel.length === 5)) {
            if (config.savePath) {
                sessionStorage.setItem('returnUrl', state.url);
            } else {
                // sessionStorage.removeItem('returnUrl');
            }

            let emailVerified = Boolean(this.authState.loginData?.user?.emailVerified ?? 0);

            if (route.url[0].path === 'login' || route.url[0].path === 'signup') {
                if (this.authState.changes$.value == "LOGGED") {
                    if (emailVerified) {
                        this.router.navigate(['/home']);
                    } else {
                        this.router.navigate(['/emailVerification']);
                    }
                    return false;
                }
            } else if (route.url[0].path === 'emailVerification' && route.url.length == 1) {
                if (this.authState.changes$.value != "LOGGED") {
                    this.router.navigate(['/login']);
                    return false;
                }
                if (emailVerified) {
                    this.router.navigate(['/home']);
                    return false;
                }
            } else {
                if (this.authState.changes$.value != "LOGGED") {
                    this.router.navigate(['/login']);
                    return false;
                }
            }
            this.nav.showNavbar = config.navbar.visible;
            (this.nav.bottomBorder as any) = config.navbar.bottomBorder;
            return true;
        } else {
            this.authState.logout(true);
            return false;
        }
    }
}